//allow empty string or numbers and allow optional + at the beginning. At least 6 digits for a valid number
export const phoneRegExp = /^(\s*|\+?(((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?))$/;
